import { CustomerReferenceType } from "../enum/Enum.ts";

export const relationShip =  [
  {
      "id": CustomerReferenceType.HUSBAND_WIFE,
      "name": "Husband/Wife",
      "code": "Husband/Wife"
  },
  {
      "id": CustomerReferenceType.SIBLING,
      "name": "Siblings",
      "code": "Siblings"
  },
  {
      "id": CustomerReferenceType.FRIEND,
      "name": "Friends",
      "code": "Friends"
  },
  {
      "id": CustomerReferenceType.PARENT,
      "name": "Parents",
      "code": "Parents"
  },
  {
      "id": CustomerReferenceType.CHILD,
      "name": "Child",
      "code": "Child"
  }
]